import water1 from './water1.png'
import water2 from './water2.png'
import water3 from './water3.png'
import water4 from './water4.png'
import water5 from './water5.png'
import water6 from './water6.png'
import water7 from './water7.png'
import water8 from './water8.png'
import water9 from './water9.png'
import water10 from './water10.png'
import water11 from './water11.png'

const waterColor = [
    water1,
    water2,
    water3,
    water4,
    water5,
    water6,
    water7,
    water8,
    water9,
    water10,
    water11
];

export default waterColor;
